import { createContext, type Dispatch, type ReactNode, type SetStateAction, useState } from "react";

type CvvContextValue = [string | undefined, Dispatch<SetStateAction<string | undefined>>];

const CvvContext = createContext<CvvContextValue>(["", () => undefined]);

export const CvvProvider = ({ children }: { children: ReactNode }) => {
  const [cvv, setCvv] = useState<string | undefined>("");

  return <CvvContext.Provider value={[cvv, setCvv]}>{children}</CvvContext.Provider>;
};

export default CvvContext;
